import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const JobPostingCard = ({ job }) => {
  const navigate = useNavigate();

  const getStatusColor = (status) => {
    switch (status) {
      case 'Active':
        return 'bg-success/10 text-success';
      case 'Expired':
        return 'bg-error/10 text-error';
      case 'Draft':
        return 'bg-warning/10 text-warning';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const handleViewCandidates = () => {
    navigate('/candidate-management', { state: { jobId: job?.id } });
  };

  const handleEditJob = () => {
    navigate('/post-new-job', { state: { jobId: job?.id, mode: 'edit' } });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 transition-smooth hover:shadow-card">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-foreground mb-2">{job?.title}</h3>
          <div className="flex flex-wrap items-center gap-3 text-sm text-muted-foreground">
            <div className="flex items-center gap-1">
              <Icon name="MapPin" size={14} />
              <span>{job?.location}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="Briefcase" size={14} />
              <span>{job?.type}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="IndianRupee" size={14} />
              <span>{job?.salary}</span>
            </div>
          </div>
        </div>
        <span className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(job?.status)}`}>
          {job?.status}
        </span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-4 pb-4 border-b border-border">
        <div>
          <p className="text-xs text-muted-foreground mb-1">Applications</p>
          <p className="text-lg font-semibold text-foreground">{job?.applications}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Views</p>
          <p className="text-lg font-semibold text-foreground">{job?.views}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Posted</p>
          <p className="text-sm text-foreground">{job?.postedDate}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Expires</p>
          <p className="text-sm text-foreground">{job?.expiryDate}</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button
          variant="default"
          size="sm"
          iconName="Users"
          iconPosition="left"
          onClick={handleViewCandidates}
        >
          View Candidates
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="Edit"
          iconPosition="left"
          onClick={handleEditJob}
        >
          Edit
        </Button>
        <Button
          variant="ghost"
          size="sm"
          iconName="BarChart3"
          iconPosition="left"
        >
          Analytics
        </Button>
      </div>
    </div>
  );
};

export default JobPostingCard;